import { MEDIA_SEGMENT_KEY, createPageSegmentLoadMetric } from '@confluence/browser-metrics';

export const MEDIA_METRIC = createPageSegmentLoadMetric({
	key: MEDIA_SEGMENT_KEY,
});
